// Universal Google Maps search URL.
// On iOS/Android with the Google Maps app installed, this opens the app
// directly. Without the app, it falls back to the web. Works for any string
// — Maps does the geocoding/best-match server-side.
//
// Reference: https://developers.google.com/maps/documentation/urls/get-started#search-action
export function buildMapsUrl(venueName: string): string {
  const query = encodeURIComponent(venueName.trim())
  return `https://www.google.com/maps/search/?api=1&query=${query}`
}
